var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 83.808 59.033",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_credit_card",
    "data-name": "icon credit card",
    transform: "translate(-663 -476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4199",
    "data-name": "Group 4199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(6331 7787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-5668 -7300.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3375",
    "data-name": "Path 3375",
    d: "M-5594.439-7226.519H-5668v-13.372a4.114,4.114,0,0,1,4.109-4.109h65.342a4.114,4.114,0,0,1,4.109,4.109Zm-70.961-2.6h68.361v-10.772a1.511,1.511,0,0,0-1.509-1.51h-65.342a1.511,1.511,0,0,0-1.51,1.51Z",
    transform: "translate(5668 7244)",
    fill: "#252b43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-5668 -7285.872)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3376",
    "data-name": "Path 3376",
    d: "M-5598.548-7112.786h-65.342A4.114,4.114,0,0,1-5668-7116.9v-29.795h73.561v29.795A4.114,4.114,0,0,1-5598.548-7112.786Zm-66.852-31.3v27.194a1.511,1.511,0,0,0,1.51,1.509h65.342a1.511,1.511,0,0,0,1.509-1.509v-27.194Zm62.55,19.527h-16.67v-12.693h16.67Zm-14.07-2.6h11.47v-7.493h-11.47Z",
    transform: "translate(5668 7146.69)",
    fill: "#252b43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-5657.753 -7311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3377",
    "data-name": "Path 3377",
    d: "M-5531.548-7262.214h-8.737v-34.43a1.511,1.511,0,0,0-1.509-1.509H-5601v-8.737a4.114,4.114,0,0,1,4.109-4.109h65.342a4.114,4.114,0,0,1,4.109,4.109v40.567A4.114,4.114,0,0,1-5531.548-7262.214Zm-6.137-2.6h6.137a1.511,1.511,0,0,0,1.509-1.51v-40.567a1.511,1.511,0,0,0-1.509-1.509h-65.342a1.512,1.512,0,0,0-1.51,1.509v6.137h56.605a4.114,4.114,0,0,1,4.109,4.109Z",
    transform: "translate(5601 7311)",
    fill: "#252b43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(-5619.521 -7276.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3378",
    "data-name": "Path 3378",
    d: "M-5334.33-7072.307H-5351V-7085h16.67Zm-14.07-2.6h11.47v-7.494h-11.47Z",
    transform: "translate(5351 7085)",
    fill: "#252b43"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCards);
export default __webpack_public_path__ + "static/media/CreditCards.0b977bbf.svg";
export { ForwardRef as ReactComponent };